import { Vehicle } from '@otw/models/inventory';

// This interface extends the base Vehicle type with additional properties that might be used in the UI
export interface ExtendedVehicle extends Vehicle {
  // We're removing images and photo-related properties to resolve TypeScript errors
}

/**
 * Get a placeholder for vehicle images
 * @returns A placeholder image URL
 */
export const getVehiclePlaceholder = (): string => {
  return 'https://via.placeholder.com/320x140?text=No+Image';
};

/**
 * Get a display value for vehicle color
 * @param vehicle The vehicle object
 * @returns A string to display for color
 */
export const getVehicleColor = (vehicle: Vehicle): string => {
  return 'N/A';
};

/**
 * Get the status from a submission status array
 * @param submissionStatuses The submission status array or undefined
 * @returns The status string or 'PENDING'
 */
export const getSubmissionStatus = (submissionStatuses: any): string => {
  if (!submissionStatuses || !Array.isArray(submissionStatuses) || submissionStatuses.length === 0) {
    return 'PENDING';
  }
  
  // Get the latest status from the array
  const latestStatus = submissionStatuses[submissionStatuses.length - 1];
  
  if (!latestStatus || !latestStatus.status) {
    return 'PENDING';
  }
  
  // Map the new status values to the old format for backward compatibility
  switch (latestStatus.status) {
    case 'Completed':
      return 'COMPLETED';
    case 'In Transit':
      return 'IN_TRANSIT';
    case 'Repair':
      return 'REPAIR';
    case 'Assigned':
    case 'Draft':
    default:
      return 'PENDING';
  }
};

/**
 * Format a vehicle for display
 * @param vehicle The original vehicle object
 * @returns A displayable vehicle object with computed properties
 */
export const formatVehicleForDisplay = (vehicle: Vehicle): Vehicle => {
  return {
    ...vehicle,
    // No additional properties needed since we removed image functionality
  };
}; 